module.exports = __webpack_public_path__ + "static/media/4_My Account.3b5259b7.jpg";